import type { InviteGigsafeUserPayload } from 'src/interfaces/gigsafeUser'
import type { InviteGigsafeUserFormValues } from './InviteGigsafeUserForm.interface'

/**
 * `marketIds` is OMITTED, not emptied, when allMarkets is true — matching Retool's
 * `marketIds: form.allMarkets ? undefined : form.marketIds` and, more importantly, the backend's
 * @ValidateIf pair. `callApi` only strips nil values from query strings, never from JSON bodies,
 * so the key must not be built here in the first place.
 *
 * The email is lowercased because `inviteUser` compares against
 * `email.trim().toLocaleLowerCase()` when checking for an existing user; sending mixed case would
 * still work, but the stored invite would not match what the duplicate check normalises to.
 */
export const mapInviteFormToPayload = (
  values: InviteGigsafeUserFormValues,
): Omit<InviteGigsafeUserPayload, 'partnerId'> => {
  const payload: Omit<InviteGigsafeUserPayload, 'partnerId'> = {
    email: values.email.trim().toLowerCase(),
    firstName: values.firstName.trim(),
    lastName: values.lastName.trim(),
    roleId: values.roleId,
    allMarkets: values.allMarkets,
  }

  if (!values.allMarkets) {
    payload.marketIds = values.marketIds
  }

  return payload
}
